import { Link } from "react-router-dom";
import "./header.css";
import { useAuctionHouseCtx } from "../../contexts/AuctionHouseProvider";

const Header = (): JSX.Element => {
    const { selectedAuctionHouse, setSelectedAuctionHouse, auctionHouses } = useAuctionHouseCtx();
    const buttons: { link?: { text: string; path: string }; elem?: JSX.Element }[] = [
        { link: { text: "Search Item", path: "/" } },
        { link: { text: "Favorites", path: "/favs" } },
    ];

    const buttonElems: JSX.Element[] = [];
    for (const btn of buttons) {
        if (btn.elem) {
            buttonElems.push(btn.elem);
        } else if (btn.link) {
            buttonElems.push(
                <Link key={btn.link.path} className="headerButton" to={btn.link.path}>
                    {btn.link.text}
                </Link>
            );
        }
    }

    const ahOptions: JSX.Element[] = [];
    if (auctionHouses) {
        for (const entry of auctionHouses) {
            ahOptions.push(
                <option key={entry.id} value={entry.id}>
                    {entry.name}
                </option>
            );
        }
    }

    return (
        <header className="headerWrap">
            {buttonElems}
            <select
                className="headerAuctionHouseSelect"
                value={selectedAuctionHouse}
                defaultValue={selectedAuctionHouse}
                onChange={(e) => setSelectedAuctionHouse(parseInt(e.target.value))}
            >
                {ahOptions}
            </select>
        </header>
    );
};

export default Header;
